import { useQuery, useQueryClient } from "@tanstack/react-query";

import { getPigletFootprintByYear, getPigletFootprintByYearAdmin } from "services";

import { getActiveToken, getEnvironment, shouldRetryQueryError, useGetCarbonProgramByFarmId, useUserContext } from "utils";

import { FOOTPRINTING_PIGLET } from "consts";

export const useGetFootprintingPigletFootprint = (farmId?: string, year?: number, { enabled = true } = {}) => {
  const isAdmin = getEnvironment().admin;
  const { user } = useUserContext();
  const queryClient = useQueryClient();
  const { data: carbonProgram } = useGetCarbonProgramByFarmId(farmId);
  const token = getActiveToken();

  const enableQuery = isAdmin
    ? (enabled && !!farmId && !!year) ?? false
    : (enabled && !!farmId && !!year && !!user && carbonProgram?.platformFeatures?.footprinting?.pork && !!token) ?? false;

  return useQuery(
    {
      queryKey: [FOOTPRINTING_PIGLET, farmId, year, isAdmin],
      queryFn: async () => (isAdmin ? getPigletFootprintByYearAdmin(farmId ?? "", year ?? 0) : getPigletFootprintByYear(year ?? 0)),
      enabled: enableQuery,
      gcTime: 60000,
      retry: shouldRetryQueryError(),
    },
    queryClient
  );
};
